import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { InputDate } from '@grapecity/wijmo.input';
import { NotNullTextAreaComponent } from '../../../../commons/kymw02/not-null-text-area/not-null-text-area.component';
import { NotNullTextInputComponent } from '../../../../commons/kymw02/not-null-text-input/not-null-text-input.component';

/**
 * EC使用画像指示画面を管理するクラス
 *
 * @export KYMW5002ImageInfoDetailBoxComponent
 * @class KYMW5002ImageInfoDetailBoxComponent
 */
@Component({
  selector: 'app-kymw5002-image-info-detail-box',
  templateUrl: 'kymw5002-image-info-detail-box.component.html',
  styleUrls: ['kymw5002-image-info-detail-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5002ImageInfoDetailBoxComponent implements OnInit {
  // 親画面からの連携値
  param: any;

  @ViewChild('txi_StartOrderCode', { static: true }) txi_StartOrderCode; // 共通部品
  @ViewChild('txi_EndOrderCode1', { static: true }) txi_EndOrderCode1; // 共通部品
  @ViewChild('cmb_EndOrderCode2', { static: true }) cmb_EndOrderCode2: ElementRef; // 共通部品
  @ViewChild('lbl_ImageName', { static: true }) lbl_ImageName: ElementRef;
  @ViewChild('lbl_ImageFileName', { static: true }) lbl_ImageFileName: ElementRef;
  @ViewChild('lbl_ImageBelongName', { static: true }) lbl_ImageBelongName: ElementRef;
  @ViewChild('lbl_ImageKindName', { static: true }) lbl_ImageKindName: ElementRef;
  @ViewChild('lbl_ImageTypeName', { static: true }) lbl_ImageTypeName: ElementRef;
  @ViewChild('cmb_ProcessInstruct', { static: true }) cmb_ProcessInstruct; // 共通部品
  @ViewChild('txi_Remarks', { static: true }) txi_Remarks: NotNullTextAreaComponent;
  @ViewChild('ckb_CookingExPublish', { static: true }) ckb_CookingExPublish: ElementRef;
  @ViewChild('txi_Priority', { static: true }) txi_Priority: NotNullTextInputComponent;
  @ViewChild('lbl_Pcode', { static: true }) lbl_Pcode: ElementRef;
  @ViewChild('lbl_GuideGoodsName', { static: true }) lbl_GuideGoodsName: ElementRef;
  @ViewChild('lbl_GuideStandardName', { static: true }) lbl_GuideStandardName: ElementRef;
  @ViewChild('txi_CookingName', { static: true }) txi_CookingName: NotNullTextInputComponent;
  @ViewChild('txi_MaterialName', { static: true }) txi_MaterialName: NotNullTextInputComponent;
  @ViewChild('txi_KeyWord', { static: true }) txi_KeyWord: NotNullTextAreaComponent;
  @ViewChild('cmb_EventId', { static: true }) cmb_EventId; // 共通部品
  @ViewChild('cmb_PhotoContentsDiv', { static: true }) cmb_PhotoContentsDiv; // 共通部品
  @ViewChild('txi_PhotoInstructContents', { static: true }) txi_PhotoInstructContents: NotNullTextAreaComponent;
  @ViewChild('dfd_PhotoSchedule', { static: true }) dfd_PhotoSchedule: InputDate;
  @ViewChild('cmb_PhotoStudioId', { static: true }) cmb_PhotoStudioId; // 共通部品
  @ViewChild('lbl_ImageInstructDate', { static: true }) lbl_ImageInstructDate: ElementRef;
  @ViewChild('lbl_FileRegistDate', { static: true }) lbl_FileRegistDate: ElementRef;
  @ViewChild('txi_Caption', { static: true }) txi_Caption: NotNullTextAreaComponent;

  @ViewChild('cmb_CookingDiv', { static: true }) cmb_CookingDiv; // 共通部品

  @Output() eventImageInfoDetailCHANGE: EventEmitter<any> = new EventEmitter;
  @Output() changeEndOrderCode2: EventEmitter<any> = new EventEmitter;

  public endOrderCode2_dataProvider = []; // コンボボックスのリスト
  public endOrderCode2: string = <string>''; // コンボボックスから取得する値

  // 画面表示用変数
  public imageName: string = <string>'';
  public imageFileName: string = <string>'';
  public imageBelongName: string = <string>'';
  public imageKindName: string = <string>'';
  public imageTypeName: string = <string>'';
  public remarks: string = <string>'';
  public cookingExPublish: boolean = <boolean>false; // チェックボックスの値
  public priority: string = <string>'';
  public pcode: string = <string>'';
  public guideGoodsName: string = <string>'';
  public guideStandardName: string = <string>'';
  public cookingName: string = <string>'';
  public materialName: string = <string>'';
  public keyWord: string = <string>'';
  public photoInstructContents: string = <string>'';
  public photoSchedule = String('');
  public imageInstructDate: string = <string>'';
  public fileRegistDate: string = <string>'';
  public caption: string = <string>'';
  public jpgUpdateDate: string = <string>'';

  // 項目非活性フラグ
  public disabledFlag = Boolean(true);

  /**
   *Creates an instance of KYMW5002ImageInfoDetailBoxComponent.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @memberof KYMW5002ImageInfoDetailBoxComponent
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.endOrderCode2_dataProvider = [{ label: '　', data: '0' }, { label: '無制限', data: '1' }, { label: '今回のみ', data: '2' }];
  }

  public clear(): void {
    // 各タグの情報初期化
    this.txi_StartOrderCode.setOrderCode('');
    this.txi_EndOrderCode1.setOrderCode('');
    this.endOrderCode2 = '-1';
    this.imageName = '';
    this.imageFileName = '';
    this.imageBelongName = '';
    this.imageKindName = '';
    this.imageTypeName = '';
    this.cmb_ProcessInstruct.setCodeValue('');
    this.remarks = '';
    this.cookingExPublish = false;
    this.priority = '';
    this.pcode = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.cmb_CookingDiv.setCodeValue('');
    this.cookingName = '';
    this.materialName = '';
    this.keyWord = '';
    this.cmb_EventId.setCodeValue('');
    this.cmb_PhotoContentsDiv.setCodeValue('');
    this.photoInstructContents = '';
    this.photoSchedule = null;
    this.cmb_PhotoStudioId.setStudioId('');
    this.imageInstructDate = '';
    this.fileRegistDate = '';
    this.caption = '';
  }
}
